import React from "react";

function Table(props) {
  return (
    <div className="bg-p-wh drop-shadow-m border-[1px] border-f-bk rounded-lg text-sm w-full">
      <table className="w-full border-collape bg-p-wh shadow-lg">
        <thead>
          <tr className="w-full">
            {props.headerRowOne?.map((header, index) => (
              <th
                key={index}
                className="py-4 px-6 text-center place-items-center"
              >
                {header}
              </th>
            ))}
          </tr>
          <tr className="w-full">
            {props.headerTwoRow?.map((header, index) => (
              <th
                key={index}
                className="pl-4 text-center place-items-center bg-[#0C1B22]"
              >
                {header.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {props.data?.map((row, index) => (
            <tr className="w-full border-t-hf" key={index}>
              <td className="py-4 px-6 text-center">{row?.currency}</td>
              <td className="py-4 px-6 text-center">{row?.usd}</td>
              <td className="py-4 px-6 text-center">{row?.perChange}</td>
              <td className="py-4 px-6 flex justify-center">{row?.chart}</td>
              <td className="py-4 px-6 text-center">{row?.action}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
//#2E6680#255266#1E4252#183542#132A35#0F222A#0C1B22Black
